/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrChildContentModule } from "igniteui-react-core";
import { IgrLabel } from './igr-label';
import { Input } from './Input';
import { TypeRegistrar } from "igniteui-react-core";
var IgrLabelModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrLabelModule() {
    }
    IgrLabelModule.register = function () {
        IgrChildContentModule.register();
        TypeRegistrar.registerCons('IgrLabel', IgrLabel);
        TypeRegistrar.registerCons('IgrLabel', IgrLabel);
        TypeRegistrar.register('Input', Input.$type);
    };
    return IgrLabelModule;
}());
export { IgrLabelModule };
//# sourceMappingURL=igr-label-module.js.map
